define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/chart_view",
    "views/common/chartjs_view",
    "views/common/chartjs_utils",
    "views/common/chartjs_options",
    "circle.progress",
    "bootstrap.datepicker"
], function($, _, Marionette, ChartView, ChartJSView, chartUtils, chartOptions, circle){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'startDailyDatepicker': '#datetimepicker_daily_start',
            'endDailyDatepicker': '#datetimepicker_daily_end',
            'startMonthlyDatepicker': '#datetimepicker_monthly_start',
            'endMonthlyDatepicker': '#datetimepicker_monthly_end',
            'dailyFilters': '.filter-daily',
            'monthlyFilters': '.filter-monthly',
            'serversList' : "#servers_list",
            'percentageToNextTier' : "#percentage_to_next_tier"
        },

        regions: {
            'circle': '#circle',
            'daily_chart': '#daily_chart',
            'monthly_chart': '#monthly_chart'
        },

        events: {
            'change @ui.serversList': function(e){
                if(e) e.preventDefault();
                window.location.href = window.baseUrl + "/report/loyalty_program_report/" + this.ui.serversList.val();
            },
            'dp.change @ui.endDailyDatepicker': function(e) {
                const endDate = $(this.ui.endDailyDatepicker).find('input').val();
                const startDate = new Date(endDate);
                startDate.setDate(startDate.getDate() - 29);
                $(this.ui.startDailyDatepicker).data('DateTimePicker').date(startDate);
                this.reloadDaily();
            },
            'dp.change @ui.endMonthlyDatepicker': function(e) {
                const endDate = $(this.ui.endMonthlyDatepicker).find('input').val();
                const startDate = new Date(endDate);
                startDate.setMonth(startDate.getMonth() - 11);
                $(this.ui.startMonthlyDatepicker).data('DateTimePicker').date(startDate);
                this.reloadMonthly();
            },
        },

        reloadDaily: function(e) {
            if(this.chartView === undefined) return;
            this.chartView.reload();
        },

        reloadMonthly: function(e) {
            if(this.monthlyChartView === undefined) return;
            this.monthlyChartView.reload();
        },

        initialize: function(){
            this.bindUIElements();
            
            var that = this;

            let percentage = window.percentage_to_next_tier ? window.percentage_to_next_tier: 0;

            // Percentage text
            $('#percentage_to_next_tier').html(percentage + '%');

            // Percentage circle
            let percentageOfBar = percentage/100;
            $('#circle').circleProgress({
                size:250,
                startAngle: Math.PI/2 ,
                value: percentageOfBar,
                thickness:9,
                lineCap:'round',
                emptyFill: "rgba(255,255,255,1)",
                fill: {gradient: ['#9a802c', '#7b6f4b']}
            })

            this.ui.startDailyDatepicker.datetimepicker({ format: 'YYYY-MM-DD' });
            this.ui.endDailyDatepicker.datetimepicker({ format: 'YYYY-MM-DD' });
            this.ui.startMonthlyDatepicker.datetimepicker({ format: 'YYYY-MM' });
            this.ui.endMonthlyDatepicker.datetimepicker({ format: 'YYYY-MM' });

            const newDate = new Date();
            const dailyDateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
            const monthlyDateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
            $(this.ui.endDailyDatepicker).data('DateTimePicker').date(dailyDateStr);
            $(this.ui.endMonthlyDatepicker).data('DateTimePicker').date(monthlyDateStr);

            this.chartView = new ChartJSView({
                ajax: {
                    url: "/rest_report/loyalty_report_daily_chart",
                    method: "POST",
                    // request data is made in ../common/chart_view.js
                    // data: {}
                    prepareData: function () {
                        const data = {};
                        that.ui.dailyFilters.each(function(){
                            data[$(this).attr("name")] = $(this).val();
                        });
                        return data;  
                    },
                    parseChartData: function (data) {
                        const clonedData = { data: [...data.data].reverse(), legend: [...data.legend].reverse() };
                        return {
                            labels: clonedData.legend,
                            datasets: [
                                {   
                                    ...chartOptions.lineChartDatasetOptions,
                                    label: "Daily loyalty volumes",
                                    data: clonedData.data.map((el) => +el),
                                },
                            ],
                        };
                    },
                },
                chartType: "line",
                chartOptions: $.extend(true, {}, chartOptions.lineChartOptions, {
                    scales: { y: { title: { text: "Daily loyalty points" } } },
                    plugins: {
                        tooltip: {external: chartUtils.customTooltip({label: "Volumes: ", offset: 9})}
                    }
                }),
                pagination: {
                    length: 30,
                    nextPagePosition: "left",
                },
                datepickerPagination: {
                    onPrevious: function () {
                        const currentDate = $(that.ui.endDailyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setDate(newDate.getDate() + 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
                        $(that.ui.endDailyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                    onNext: function () {
                        const currentDate = $(that.ui.endDailyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setDate(newDate.getDate() - 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
                        $(that.ui.endDailyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                }
            });
            this.showChildView('daily_chart', this.chartView);

            this.monthlyChartView = new ChartJSView({
                ajax:{
                    url: '/rest_report/loyalty_report_monthly_chart',
                    method: "POST",
                    prepareData: function () {
                        const data = {};
                        that.ui.monthlyFilters.each(function(){
                            data[$(this).attr("name")] = $(this).val();
                        });
                        return data;  
                    },
                    parseChartData: function (data) {
                        const clonedData = { data: [...data.data].reverse(), legend: [...data.legend].reverse()};
                        return {
                            labels: clonedData.legend,
                            datasets: [
                                {
                                    ...chartOptions.barChartDatasetOptions,
                                    label: "Monthly loyalty points",
                                    data: clonedData.data.map(el => +el),
                                },
                            ],
                        };
                    },
                },
                chartType: "bar",
                chartOptions: $.extend(true, {}, chartOptions.barChartOptions, {
                    scales: { y: { title: { text: "Monthly loyalty points" } } },
                    plugins: {
                        tooltip: {external: chartUtils.customTooltip({label: "Volumes: "})}
                    }
                }),
                chartPlugins: [chartUtils.MirrorEffect],
                pagination: {
                    length: 12,
                    nextPagePosition: 'left'
                },
                datepickerPagination: {
                    onPrevious: function () {
                        const currentDate = $(that.ui.endMonthlyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setMonth(newDate.getMonth() + 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
                        $(that.ui.endMonthlyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                    onNext: function () {
                        const currentDate = $(that.ui.endMonthlyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setMonth(newDate.getMonth() - 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
                        $(that.ui.endMonthlyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                }
            });
            this.showChildView('monthly_chart', this.monthlyChartView);
        }
    });
});
